// src/pages/VerifyListingLanding.jsx
//
// Public, no-login-required landing page for the pan-India "Verify Listing"
// ad campaign. One generic URL for every city -- targeting happens on the
// ad platform side (UTM params etc.), not via separate per-city pages.
//
// Visitors who register from here are flagged toolOnlyAccess on the backend
// (see Signup.js, which reads the toolOnlyEntry flag set below) and, once
// logged in, only ever see the Verify Listing tool -- no sidebar, no
// property browsing -- until their city has live listings (DashboardLayout
// handles that gating). This page itself never shows the app nav.
import React, { useEffect } from "react";
import { MapPin, CheckCircle2, ShieldCheck } from "lucide-react";
import Signup from "../components/Signup";

const VerifyListingLanding = () => {
  useEffect(() => {
    localStorage.setItem("toolOnlyEntry", "true");
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-[#503691] to-[#7c3aed] text-white">
        <div className="max-w-5xl mx-auto px-4 py-8 sm:py-10 text-center">
          <div className="inline-flex items-center gap-2 bg-white/15 rounded-full px-4 py-1.5 text-sm font-medium mb-4">
            <MapPin className="w-4 h-4" />
            Available across India
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold">
            Verify Your Property Listing in Seconds
          </h1>
          <p className="text-white/85 mt-2 max-w-xl mx-auto text-sm sm:text-base">
            Upload property photos, stamp them with real GPS location and time, and prove your
            listing is genuine -- no site visit needed.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-5 text-sm">
            <span className="flex items-center gap-1.5">
              <CheckCircle2 className="w-4 h-4" /> 3 free verifications
            </span>
            <span className="flex items-center gap-1.5">
              <ShieldCheck className="w-4 h-4" /> Real GPS + timestamp proof
            </span>
            <span className="flex items-center gap-1.5">
              <CheckCircle2 className="w-4 h-4" /> No credit card needed to start
            </span>
          </div>
        </div>
      </div>

      <Signup />
    </div>
  );
};

export default VerifyListingLanding;
